const axios = require("axios");
axios.defaults.withCredentials = true;
const API_ENDPOINT = (process.env.NODE_ENV === 'production') ? `${process.env.REACT_APP_API_END_POINT}/api` : '/api';
const client = {
  get: async (url: string, params: any) => {
    try {
      //console.log(`${API_ENDPOINT}${url}`)
      let token = client.getAuth();
      let response = await axios.get(`${API_ENDPOINT}${url}`, {
        params: params,
        headers: { "x-token": `Bearer ${token}` },
      });
      return {
        error: false,
        ...response.data,
      };
    } catch (error: any) {
      window.snakAlert.error(error.toString());
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  getAll: async (url: string) => {
    try {
      //console.log(`${API_ENDPOINT}${url}`)
      let token = client.getAuth();
      let response = await axios.get(`${API_ENDPOINT}${url}`, {
        headers: { "x-token": `Bearer ${token}` },
      });
      return {
        error: false,
        ...response.data,
      };
    } catch (error: any) {
      window.snakAlert.error(error.toString());
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  post: async (url: string, params: any) => {
    try {
      let token = client.getAuth();
      let response = await axios.post(`${API_ENDPOINT}${url}`, params, {
        headers: { "x-token": `Bearer ${token}` },
      });
      return {
        error: false,
        ...response.data,
      };
    } catch (error: any) {
      window.snakAlert.error(error.toString());
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  put: async (url: string, params: any) => {
    try {
      let token = client.getAuth();
      let response = await axios.put(`${API_ENDPOINT}${url}`, params, {
        headers: { "x-token": `Bearer ${token}` },
      });
      return {
        error: false,
        ...response.data,
      };
    } catch (error: any) {
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  delete: async (url: string, params: any) => {
    try {
      let token = client.getAuth();
      let response = await axios.delete(`${API_ENDPOINT}${url}`, {
        data: params,
        headers: { "x-token": `Bearer ${token}` },
      });
      return {
        error: false,
        ...response.data,
      };
    } catch (error: any) {
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  upload: async (type: string, blob: any) => {
    const form: any = new FormData();
    form.append("file", blob);
    form.append("type", type); // banners|products|etc
    try {
      let token = client.getAuth();
      let response = await axios.put(`${API_ENDPOINT}/upload`, form, {
        headers: {
          "x-token": `Bearer ${token}`,
          "content-type": "multipart/form-data; ",
        },
      });
      return {
        error: false,
        ...response.data,
      };
    } catch (error: any) {
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  getFile: async (url: string, params: any) => {
    try {
      //console.log(`${API_ENDPOINT}${url}`)
      let token = client.getAuth();
      let response = await axios.get(`${API_ENDPOINT}${url}`, {
        params: params,
        responseType: 'blob',
        headers: { "x-token": `Bearer ${token}` },
      });
      return {
        error: false,
        ...response,
      };
    } catch (error: any) {
      window.snakAlert.error(error.toString());
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  getAuth: () => {
    let auth: any = window.localStorage.getItem("auth");
    if (auth) {
      auth = JSON.parse(auth);
      return auth.token;
    }
  },
  externalRequest: async (apiUrl: string, token?: string | undefined) => {
    try {
      let config = {
        method: "GET",
        withCredentials: false,
        url: apiUrl,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.request(config);
      return {
        error: false,
        data: response.data,
      };
    } catch (error: any) {
      console.error("External API Error:", error);
      return {
        error: true,
        message: error.toString(),
      };
    }
  },
  // xanoRequest: async (url: string, method: string, params: any) => {
  //   try {
  //     let response = await axios({
  //       method: method,
  //       url: `${XANO_API_ENDPOINT}${url}`,
  //       data: params
  //     });
  //     return {
  //       error: false,
  //       ...response.data,
  //     };
  //   } catch (error: any) {
  //     console.error("XANO API Error:", error);

  //     return {
  //       error: true,
  //       message: error.toString(),
  //     };
  //   }
  // }
};

export default client;
